import React from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import { TextField } from '../text-field';
import search from '../../assets/svg/search.svg';
import close from '../../assets/svg/close2.svg';
import useStyles from './search-bar.styles';

const SearchBar = ({ value, onInputFocus, onCloseIconClick, onInputChange, label }) => {
  const classes = useStyles();
  const searchIcon = (
    <InputAdornment position="end">
      <img src={search} alt="" width="32" />
    </InputAdornment>
  );

  const closeIcon = (
    <InputAdornment position="end" style={{ zIndex: 2 }}>
      <IconButton onClick={onCloseIconClick} size="small">
        <img src={close} alt="close" width="32" />
      </IconButton>
    </InputAdornment>
  );

  const adornment = value ? closeIcon : searchIcon;

  return (
    <>
      <TextField
        mode="light"
        className={classes.searchBar}
        InputProps={{
          endAdornment: adornment,
          value
        }}
        label={label}
        name="usersSearch"
        id="usersSearch"
        value={value}
        onChange={onInputChange}
        onFocus={onInputFocus}
      />
    </>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string,
  onInputFocus: PropTypes.func,
  onCloseIconClick: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  label: PropTypes.string
};

SearchBar.defaultProps = {
  value: '',
  onInputFocus: null,
  onInputChange: null,
  label: ''
};
export default SearchBar;
